import { Button, dialog, InfiniteScroll, Progress } from "../../../../../nq-component";
import {
  countObjectUseCase,
  deleteObjectUseCase,
  findObjectUseCase,
  upsertUseCase,
} from "../../../../../usecases/object";
import withRouter from "../../../../../withRouter";
import Search from "../../../../../components/Search";
import BaseListPage from "../../../../../base/BaseListPage";
import { toDisplayCase } from "../../../../../nq-component";
import RawMaterialPresenter from "./RawMaterialPresenter";
import NavBar from "../../../../../components/navbar";
import Table from "../../../../../components/Table";
import CollapseView from "./components/CollapseView";
import DialogModal from "../../../../../components/Dialog";
import Select from "react-select";
import PageHeader from "../../../../../components/PageHeader";

class RawMaterialPage extends BaseListPage {
  constructor(props) {
    super(props);
    this.presenter = new RawMaterialPresenter(
      this,
      findObjectUseCase(),
      countObjectUseCase(),
      deleteObjectUseCase(),
      upsertUseCase(),
    );
    this.state = {
      ...this.state,
      categories: [],
      selectedCategory: null,
    };
  }

  getCollectionName() {
    return "raw_materials";
  }

  onCategoryChange(selectedOption) {
    this.setState({ selectedCategory: selectedOption });

    if (selectedOption) {
      // Filter by category
      this.searchSubmit({ "category.id": selectedOption.value });
    } else {
      // Clear category filter
      this.searchSubmit({});
    }
  }

  closeDialog() {
    dialog.close();
  }

  onClickAdd() {
    this.presenter.onClickAdd();
  }

  onClickEdit(index) {
    this.presenter.onClickEdit(index);
  }

  onClickDelete(index) {
    dialog.fire({
      html: (
        <DialogModal
          icon="bi bi-exclamation-octagon-fill"
          iconColor="red"
          title="Confirm Deletion"
          message="This will remove the selected data from the system. Are you sure want to continue?"
          isCancelButton={true}
          onSubmit={() => this.presenter.onClickDelete(index)}
          onClose={() => dialog.close()}
        />
      ),
      footer: false,
    });
  }

  onCollapse(index) {
    const raw = this.state.objects[index];
    return (
      <CollapseView
        raw={raw}
        onEdit={() => this.onClickEdit(index)}
        onDelete={() => this.onClickDelete(index)}
      />
    );
  }

  formatFields(fields) {
    const { storeId, ...rest } = fields;

    return {
      ...rest,
    };
  }

  formatObjects(objects) {
    return objects.map((object) => {
      const { ...rest } = object || {};

      return {
        ...rest,
      };
    });
  }

  render() {
    const schema = this.getSchema(this.getCollectionName());
    const { objects, selected, count, loading, categories, selectedCategory } =
      this.state;

    if (!schema) return <Progress />;
    return (
      <>
        <NavBar />
        <div className="overflow-auto">
          <InfiniteScroll
            className="h-100"
            loadMore={this.loadMore.bind(this)}
            hasMore={!loading && count > objects.length}
          >
            <div className="p-3 p-lg-4">
              <div className="d-flex justify-content-between align-items-center">
                <PageHeader
                  title={
                    schema.label || toDisplayCase(this.getCollectionName())
                  }
                  subtitle={schema.description || "List of all Raw Materials"}
                  icon="bi bi-box-seam"
                />
                <div className="text-nowrap">
                  <span className="ms-2">
                    {selected.length > 0 ? "Selected: " : "Total: "}
                  </span>
                  <span className="fs-sm text-nowrap">
                    {selected.length > 0 ? selected.length : objects.length}
                  </span>
                  <span className="ms-1">of </span>
                  <span className="fs-sm text-nowrap">{count}</span>
                </div>
              </div>

              <div className="p-3 p-lg-3 bg-white border rounded-4 shadow-sm">
                <div className="d-flex align-items-center justify-content-between mb-2">
                  <div className="d-flex align-items-center gap-2">
                    <i className="bi bi-funnel text-primary" />
                    <span className="fw-semibold">Filters</span>
                    <span className="text-muted small">
                      Refine your inventory list
                    </span>
                  </div>
                </div>

                <div className="row g-3 align-items-end">
                  <div className="col-lg-7 col-12">
                    <label className="form-label small text-muted mb-1">
                      Search
                    </label>
                    <div className="position-relative">
                      <div style={{ paddingLeft: 2 }}>
                        <Search
                          schemas={this.getSchemas()}
                          onSubmit={this.searchSubmit.bind(this)}
                          fields={schema.fields}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-5 col-12">
                    <label className="form-label small text-muted mb-1">
                      Category
                    </label>
                    <Select
                      value={selectedCategory}
                      onChange={this.onCategoryChange.bind(this)}
                      options={categories}
                      isClearable
                      placeholder="All categories"
                      className="react-select-container"
                      classNamePrefix="react-select"
                      styles={{
                        control: (base, state) => ({
                          ...base,
                          minHeight: "44px",
                          borderRadius: "14px",
                          borderColor: state.isFocused
                            ? "#86b7fe"
                            : base.borderColor,
                          boxShadow: state.isFocused
                            ? "0 0 0 .2rem rgba(13,110,253,.15)"
                            : "none",
                        }),
                        valueContainer: (base) => ({
                          ...base,
                          paddingLeft: 12,
                        }),
                        placeholder: (base) => ({ ...base, color: "#6c757d" }),
                      }}
                    />
                  </div>
                </div>
              </div>

              <Table
                fields={schema.fields}
                objects={objects}
                selectable
                collapsable
                excludeFields={Object.keys(schema.fields).reduce(
                  (acc, key) => {
                    const options = schema.fields[key];
                    if (options.read === false) {
                      acc.push(key);
                    }
                    switch (options._type || options.type) {
                      case "Relation":
                      case "Array":
                      case "Object":
                      case "File":
                        acc.push(key);
                        break;
                      default:
                    }
                    return acc;
                  },
                  ["acl", "password", "storeId"],
                )}
                selected={selected}
                onSelect={this.onSelect.bind(this)}
                onSelectAll={this.onSelectAll.bind(this)}
                onCollapse={this.onCollapse.bind(this)}
                //  progress={progress}
                onClickItem={this.onClickItem.bind(this)}
                className="mt-3"
              />
            </div>
          </InfiniteScroll>
        </div>
        <div className="position-fixed bottom-0 end-0 m-4">
          <Button
            className="btn shadow-sm"
            onClick={this.onClickAdd.bind(this)}
            style={{
              width: "50px",
              height: "50px",
              borderRadius: "25px",
              backgroundColor: "#82c14a",
              color: "white",
            }}
          >
            <i className="bi bi-plus-lg" />
          </Button>
        </div>
      </>
    );
  }
}

export default withRouter(RawMaterialPage);
